// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/Home.vue';
import About from '../components/About.vue';
import Services from '../components/Services.vue';
import Cases from '../components/Cases.vue';

const routes = [
    { path: '/', component: Home },
    { path: '/about', component: About },
    { path: '/cases', component: Cases },
    { path: '/services', component: Services }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;